import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledFlex = styled.div `
    display: flex;
    flex-direction: ${props => (props.column ? 'column' : 'row')};
    align-items: ${props => props.alignItems};
    justify-content: ${props => props.justifyContent};
    padding: ${props => props.padding};
    margin: ${props => props.margin};
    gap: ${props => props.gap};
    flex: ${props => props.flex};
    width: ${props => (props.fullWidth ? '100%' : 'auto')};
    max-width: ${props => props.maxWidth};
    flex-wrap: ${props => props.flexWrap};
`;
const StyledSpacer = styled.span `
    flex: 1 1 auto;
`;
const Flex = ({ className, children, column, alignItems, justifyContent, padding, margin, gap, flex, fullWidth, flexWrap, maxWidth, }) => (_jsx(StyledFlex, { className: className, column: column, alignItems: alignItems, justifyContent: justifyContent, padding: padding, margin: margin, gap: gap, fullWidth: fullWidth, flex: flex, flexWrap: flexWrap, maxWidth: maxWidth, children: children }));
export default Object.assign(Flex, {
    Spacer: StyledSpacer,
});
